import { Directive, TemplateRef, ViewContainerRef, Input, ComponentFactoryResolver, OnInit } from '@angular/core';
import { DVFormGroup } from '../dynamic-validator';
import { DvInputWrapperComponent } from '../dv-input-wrapper/dv-input-wrapper.component';

@Directive({
  selector: '[dvFieldError]'
})
export class DVErrorRefDirective implements OnInit {
  @Input('dvFieldError')fieldName: string;
  @Input('dvFieldErrorFrom') fg: DVFormGroup;


  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainerRef: ViewContainerRef,
    private cfr: ComponentFactoryResolver,
  ) { }

  ngOnInit() {
    const factory = this.cfr.resolveComponentFactory(DvInputWrapperComponent);
    const inputComponent = this.viewContainerRef.createComponent(factory);
    inputComponent.instance.fieldName = this.fieldName;
    inputComponent.instance.inputTemplate = this.templateRef;
    inputComponent.instance.parentFormGroup = this.fg;
  }

}
